import { DateTime } from 'luxon';

import { Conditional, DateTimeValue, Operator, TextValue } from 'dashboard/models/graph-query';

class InvalidConditionalError extends Error {
  constructor(message: string) {
    super(message);

    Object.setPrototypeOf(this, InvalidConditionalError.prototype);
  }
}

// Returns [lowerBound, upperBound], at most one of which may be null.
const parseDateTimeRangeConditional = (
  conditional: Conditional,
): [DateTime | null, DateTime | null] => {
  if (conditional.operator === Operator.Before) {
    if (conditional.right.length !== 1) {
      throw new InvalidConditionalError('Expected exactly one argument after IsBefore');
    }
    return [null, DateTime.fromISO((conditional.right[0] as unknown as DateTimeValue).moment)];
  } else if (conditional.operator === Operator.After) {
    if (conditional.right.length !== 1) {
      throw new InvalidConditionalError('Expected exactly one argument after IsAfter');
    }
    return [DateTime.fromISO((conditional.right[0] as unknown as DateTimeValue).moment), null];
  } else if (conditional.operator === Operator.Between) {
    if (conditional.right.length !== 1) {
      throw new InvalidConditionalError('Expected exactly one time range for IsBetween');
    }
    const dateRangeValue = conditional.right[0] as unknown as [DateTimeValue, DateTimeValue];
    return [DateTime.fromISO(dateRangeValue[0].moment), DateTime.fromISO(dateRangeValue[1].moment)];
  } else {
    throw new InvalidConditionalError('Expected created_at to be: IsBefore, IsAfter, or IsBetween');
  }
};

const parseTextValuesFromConditional = (conditional: Conditional): string[] => {
  return conditional.right.map((textValue) => (textValue as TextValue).value);
};

const parseDateTimeValuesFromConditional = (conditional: Conditional): DateTime[] => {
  return conditional.right.map((dateTimeValue) =>
    DateTime.fromISO((dateTimeValue as unknown as DateTimeValue).moment),
  );
};

export {
  InvalidConditionalError,
  parseDateTimeRangeConditional,
  parseTextValuesFromConditional,
  parseDateTimeValuesFromConditional,
};
